import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.html.*
import kotlinx.html.dom.*

const val host = "tiulp.in"
const val aiModel = "Llama-3.2-3B-Instruct-q4f32_1-MLC"

const val consoleId = "console"
const val consoleLine = "console-line"
const val consoleBody = "body"

fun main() {
    document.body!!.append.div {
        id = consoleId
        div(consoleLine) {
            p {
                unsafe {
                    +files.first().content
                }
            }
        }
        div("$consoleLine active") {
            div("prompt") {
                pre {
                    +"$host › "
                }
            }
            div(consoleBody)
        }
    }
    Console.init()
    Console.setLine("tree")
    Console.enter()
    window.onkeydown = {
        when (it.key) {
            "Backspace" -> Console.backspace()
            "Tab" -> Console.tab()
            "Enter" -> Console.enter()
            "ArrowUp" -> Console.up()
            "ArrowDown" -> Console.down()
            else -> Console.input(it)
        }
        if (Console.preventDefault) {
            it.preventDefault()
        }

        if (it.key == " " && commands[Console.getLine().trim()] == null) {
            Console.AI.setAIPrompt()
        } else if (Console.getLine().isEmpty()) {
            Console.AI.resetPrompt()
        }
    }
}
